//Copyright (C) Siemens Healthineers AG 2024, All rights reserved. Restricted
//

(function () {
    'use strict';
    angular.module('container.components')
        .directive('srsngCookiePolicy', srsngCookiePolicy);

    function srsngCookiePolicy($rootScope, Event) {

        return {
            restrict: 'E',
            templateUrl: 'container/ui/app/components/software-info/cookie-policy/cookie-policy.html',
            scope: {
            },
            controller: controller
        };

        function controller($scope) {
            // this is intentional override
        }

    }

})();

